import { useQuery } from "@tanstack/react-query";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { getTopMatchedApplicants } from "../services/job.services";

export const useGetTopMatchedApplicants = ({ jobId }: { jobId?: string | number }) =>
  useQuery({
    queryKey: GO_HIRE_QUERY_KEYS.topMatchedApplicants(jobId!),
    queryFn: () => getTopMatchedApplicants(jobId!),
    enabled: !!jobId,
  });
